import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Container, Card, CardBody, CardHeader, Button, Alert } from 'reactstrap';

export const TokenDebug = () => {
  const auth = useAuth();
  const [debugResult, setDebugResult] = useState(null);
  const [error, setError] = useState(null);

  const testToken = async () => {
    try {
      setError(null);
      console.log('Token:', auth.token);
      console.log('Auth headers:', auth.getAuthHeaders());
      
      const response = await fetch('/api/auth/debug-token', {
        headers: {
          ...auth.getAuthHeaders()
        }
      });

      if (response.ok) {
        const result = await response.json();
        setDebugResult(result);
        console.log('Debug result:', result);
      } else {
        setError(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (err) {
      setError(`Network error: ${err.message}`);
    }
  };

  const testWorkCategories = async () => {
    try {
      setError(null);

      const response = await fetch('/api/workcategories/hierarchy', {
        headers: {
          ...auth.getAuthHeaders()
        }
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Work categories result:', result);
        setDebugResult({ workCategories: result });
      } else {
        setError(`Work Categories HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (err) {
      setError(`Work Categories Network error: ${err.message}`);
    }
  };

  const testManagerPolicy = async () => {
    try {
      setError(null);

      const response = await fetch('/api/auth/test-manager-policy', {
        headers: {
          ...auth.getAuthHeaders()
        }
      });

      if (response.ok) {
        const result = await response.json();
        setDebugResult({ managerPolicy: result });
      } else {
        setError(`Manager Policy HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (err) {
      setError(`Manager Policy Network error: ${err.message}`);
    }
  };

  const testAdminPolicy = async () => {
    try {
      setError(null);

      const response = await fetch('/api/auth/test-admin-policy', {
        headers: {
          ...auth.getAuthHeaders()
        }
      });

      if (response.ok) {
        const result = await response.json();
        setDebugResult({ adminPolicy: result });
      } else {
        setError(`Admin Policy HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (err) {
      setError(`Admin Policy Network error: ${err.message}`);
    }
  };

  return (
    <Container className="mt-3">
      <Card>
        <CardHeader>
          <h5>Token Debug</h5>
        </CardHeader>
        <CardBody>
          <div className="mb-3">
            <strong>Is Authenticated:</strong> {auth.isAuthenticated() ? 'Yes' : 'No'}
          </div>
          <div className="mb-3">
            <strong>Is Admin:</strong> {auth.isAdmin() ? 'Yes' : 'No'}
          </div>
          <div className="mb-3">
            <strong>Is Manager:</strong> {auth.isManager() ? 'Yes' : 'No'}
          </div>
          <div className="mb-3">
            <strong>Token exists:</strong> {auth.token ? 'Yes' : 'No'}
          </div>
          <div className="mb-3">
            <strong>Token (first 50 chars):</strong> {auth.token ? auth.token.substring(0, 50) + '...' : 'None'}
          </div>
          
          <div className="mb-3">
            <Button color="primary" onClick={testToken} className="me-2 mb-2">
              Test Token Endpoint
            </Button>
            <Button color="secondary" onClick={testWorkCategories} className="me-2 mb-2">
              Test Work Categories
            </Button>
            <Button color="info" onClick={testManagerPolicy} className="me-2 mb-2">
              Test Manager Policy
            </Button>
            <Button color="warning" onClick={testAdminPolicy} className="mb-2">
              Test Admin Policy
            </Button>
          </div>

          {error && (
            <Alert color="danger">
              {error}
            </Alert>
          )}

          {debugResult && (
            <div>
              <strong>Debug Result:</strong>
              <pre style={{fontSize: '12px', backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '4px'}}>
                {JSON.stringify(debugResult, null, 2)}
              </pre>
            </div>
          )}
        </CardBody>
      </Card>
    </Container>
  );
};
